import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Phone, MessageCircle, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';

const ProntoInterventoRomaCentroZTL = () => {
  const handleCall = () => {
    window.location.href = 'tel:3287686356';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20un%20pronto%20intervento%20urgente%20in%20Centro%20Roma%20ZTL.', '_blank');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Pronto Intervento Roma Centro ZTL H24 | Idraulico Elettricista</title>
        <meta name="description" content="Pronto intervento Roma Centro ZTL H24. Idraulico, elettricista, caldaie. Arriviamo in 30-60 minuti anche in zone a traffico limitato. Tel: 328 768 6356" />
        <link rel="canonical" href={`${window.location.origin}/pronto-intervento-roma-centro-ztl`} />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <section className="bg-gradient-to-br from-blue-50 to-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center justify-center gap-2 mb-6">
                <MapPin className="h-8 w-8 text-blue-700" />
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                  Pronto Intervento Roma Centro ZTL
                </h1>
              </div>
              
              <p className="text-xl text-gray-700 text-center mb-8">
                Pronto intervento H24 Centro Storico, Trevi, Pantheon, Campo de' Fiori, Trastevere. Arriviamo in 30-60 minuti anche in zone a traffico limitato.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                <Button onClick={handleWhatsApp} size="lg" className="bg-orange-500 hover:bg-orange-600 text-white text-xl px-10 py-7">
                  <MessageCircle className="mr-3 h-7 w-7" />
                  WhatsApp Urgente
                </Button>
                <Button onClick={handleCall} size="lg" className="bg-blue-700 hover:bg-blue-800 text-white text-xl px-10 py-7">
                  <Phone className="mr-3 h-7 w-7" />
                  328 768 6356
                </Button>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Interventi Urgenti Centro Storico Roma - Accesso ZTL
                </h2>
                <p className="text-gray-700 text-lg mb-4">
                  SOS Casa Roma è autorizzata ad operare in tutte le zone ZTL del Centro Storico di Roma. I nostri mezzi sono abilitati all'accesso nelle zone a traffico limitato per garantire interventi rapidi anche nelle aree più centrali e turistiche della capitale.
                </p>
                <p className="text-gray-700 text-lg mb-4">
                  <strong>Zone coperte:</strong> Centro Storico, Trevi, Pantheon, Piazza Navona, Campo de' Fiori, Trastevere, Monti, Colosseo, Fori Imperiali, Via del Corso, Via Veneto, Piazza di Spagna.
                </p>
                <p className="text-gray-700 text-lg mb-4">
                  <strong>Servizi disponibili in ZTL:</strong> Idraulico urgente, elettricista, riparazione caldaie, climatizzatori, perdite acqua, guasti elettrici, scarichi intasati.
                </p>
                <p className="text-gray-700 text-lg">
                  <strong>Accesso garantito:</strong> Arriviamo in 30-60 minuti anche in zone a traffico limitato con autorizzazione regolare per tutte le ZTL romane.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
        <FloatingWhatsApp />
      </div>
    </>
  );
};

export default ProntoInterventoRomaCentroZTL;
